import layout from './layout'
import devices from './devices'
import styles from './styles'
import collabs from './collabs'
import personalize from './personalize'
import landing from './landing'
import ribbon from './ribbon'
import navigation from './navigation'
import products from './products'
import search from './search'
import checkout from './checkout'
import orderConfirmation from './orderConfirmation'
import footer from './footer'
import authen from './authen'
import otp from './otp'
import createUser from './createUser'
import cookie from './cookie'
import cart from './cart'
import faqs from './faqs'
import terms from './terms'
import myAccount from './myAccount'
import visitUs from './pages/visitUs'
import personalization from './personalization'

// page
import forgotPassword from './pages/forgotPassword'
import signUp from './pages/signUp'
import signIn from './pages/signIn'
import termsAndConditions from './pages/termsAndConditions'
import personalDataConsent from './pages/personalDataConsent'
import privacyPolicy from './pages/privacyPolicy'
import promotions from './pages/promotions'
import blogs from './pages/blogs'
import home from './pages/home'
import notFound from './pages/notFound'
import aboutUs from './pages/aboutUs'
import blog from './pages/blog'

// component
import alert from './alert'
import modal from './modal'

// page account
import myAddress from './pages/account/myAddress'
import wishlist from './pages/account/wishlist'
import myOrder from './pages/account/myOrder'

export default defineI18nLocale(() => ({
  layout,
  devices,
  styles,
  collabs,
  personalize,
  landing,
  ribbon,
  navigation,
  products,
  search,
  checkout,
  orderConfirmation,
  footer,
  authen,
  otp,
  createUser,
  cookie,
  cart,
  faqs,
  aboutUs,
  terms,
  myAccount,
  personalization,

  pages: {
    home,
    forgotPassword,
    signUp,
    signIn,
    termsAndConditions,
    personalDataConsent,
    privacyPolicy,
    promotions,
    blogs,
    notFound,
    visitUs,
    aboutUs,
    blog
  },

  components: {
    alert,
    modal
  },

  account: {
    myAddress,
    wishlist,
    myOrder
  },
}))
